import { firestoreDatabase } from 'lib/firebaseService';
import { fbAuth } from 'lib/firebaseService';
import { AdminUserRole, IGetAdminUsers } from 'interfaces';

export const ADMIN_USERS_RESOURCE = 'admin_users';
export const UNLIMITED_OFFER_LIMIT = 0;

export const getRoleByEmail = async (
  email: string,
): Promise<AdminUserRole | null> => {
  const response = await firestoreDatabase.getList({
    resource: ADMIN_USERS_RESOURCE,
    filters: [
      {
        field: 'email',
        operator: 'eq',
        value: email.trim().toLowerCase(),
      },
    ],
    pagination: {
      current: 1,
      pageSize: 1,
    },
  });

  const adminUser = response.data?.[0] as IGetAdminUsers | undefined;
  return adminUser ? (adminUser.role as AdminUserRole) : null;
};

export const getAdminUserByEmail = async (
  email: string,
): Promise<IGetAdminUsers | null> => {
  const response = await firestoreDatabase.getList({
    resource: ADMIN_USERS_RESOURCE,
    filters: [
      {
        field: 'email',
        operator: 'eq',
        value: email.trim().toLowerCase(),
      },
    ],
    pagination: {
      current: 1,
      pageSize: 1,
    },
  });

  return (response.data?.[0] as IGetAdminUsers | undefined) || null;
};

export const getCurrentAdminUser =
  async (): Promise<IGetAdminUsers | null> => {
    const _email = fbAuth.currentUser?.email || '';
    const email = _email.trim().toLowerCase();
    if (!email) {
      throw new Error('Current user email is not available');
    }

    return getAdminUserByEmail(email);
  };

export const getOfferLimit = async (): Promise<{
  uid: string;
  role: AdminUserRole;
  offerLimit: number;
}> => {
  const currentAdminUser = await getCurrentAdminUser();
  if (!currentAdminUser) {
    throw new Error('Current admin user is not available');
  }

  const uid = currentAdminUser.auth_uid;
  const offerLimit =
    currentAdminUser.offer_limit || UNLIMITED_OFFER_LIMIT;

  return {
    uid,
    role: currentAdminUser.role as AdminUserRole,
    offerLimit,
  };
};
